const nonBreakingText = txt => txt ? txt.replace(/ /g, "\u00a0") : txt;

export default nonBreakingText;
